import { Injectable } from '@angular/core';
import {
  Resolve,
} from '@angular/router';
import { Menu } from '@app/models/menu.model';
import { SetCareConneRoomList, SetRenderedDataNote } from '@app/store/data/data.classes';
import { InitAliasId, SetCorpPrefix, SetWebView } from '@app/store/setting/setting.classes';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Store } from '@ngxs/store';
import { map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebviewMenuResolverService implements Resolve<Menu[]> {

  constructor(private store: Store) { }

  resolve(): Observable<Menu[]> {
    const actions = [
      new SetWebView(true),
      new InitAliasId(),
      // new SetScheduleTitleList(),
      // new SetWebviewMenuList(corpPrefix),
      // new SetButtonTitleList(true, corpPrefix),
      // new BoardAction.FetchLastUpdateDatetime(),
      new SetCareConneRoomList({}),
      new SetRenderedDataNote({})
    ];

    return this.store
      .dispatch(actions)
      .pipe(map(() => this.store.selectSnapshot(SettingSelectors.menuList)));
  }
}

@Injectable({
  providedIn: 'root'
})
export class CorpPrefixResolverService implements Resolve<boolean> {
  constructor(private store: Store) { }

  resolve(): Observable<boolean> {
    // throw new Error('Method not implemented.');
    // if office change ==> new menu
    // if corpPrefix change ==> new menu
    // fetch once only (for performance)
    this.store.dispatch(new SetCorpPrefix)
    return of(true)
  } 

}